import { cn } from "@/lib/utils";

export const SectionHeader = ({
  overline,
  title,
  description,
  align = "left",
  light = false,
  className,
}) => (
  <div
    className={cn(
      align === "center" ? "mx-auto max-w-2xl text-center" : "max-w-2xl",
      className,
    )}
  >
    {overline && (
      <div
        className={cn(
          "mb-4 flex items-center gap-3 font-heading text-xs font-bold uppercase tracking-[0.2em]",
          align === "center" && "justify-center",
        )}
      >
        <span className="h-px w-8 bg-gold" />
        <span className="text-gold">{overline}</span>
      </div>
    )}
    <h2
      className={cn(
        "font-heading text-3xl font-extrabold tracking-tight sm:text-4xl lg:text-5xl",
        light ? "text-ink" : "text-white",
      )}
    >
      {title}
    </h2>
    {description && (
      <p
        className={cn(
          "mt-5 text-base leading-relaxed sm:text-lg",
          light ? "text-ink/70" : "text-steel",
        )}
      >
        {description}
      </p>
    )}
  </div>
);
